var cannotLoadAjax = "Can not process your request";
var defaultKeyword = "Enter your product question or search term";

document.addEventListener('DOMContentLoaded', function() {  
  $('#keyword').keydown(function (event) {
    if (event.keyCode == 13) {
      searchFAQs();
      $('#keyword').focus();
    }
  });

});

function searchFAQs() {
  var keyword = $("#keyword").val();
  if (keyword == defaultKeyword) {
    keyword = "";
  }

  $('#ModalContentAjax').modal("show");
  var totalPage = 0;
  var requestData = 'keyword=' + keyword;
  xhr = $.ajax({
    url: "/apps/innova-api/supports/search-faqs",
    cache: false,    
    type: 'post',
    data: requestData,
    error: function () {
      $('#ModalContentAjax').modal("hide");
      alert(cannotLoadAjax);
    },
    success: function (result) {
      if(result.message.success){
        $('#support-wrapper').html(result.faqResult);            
      }
      $('#ModalContentAjax').modal("hide");      

    }
  });

}
